import { isBrowser } from 'common/utils'
import { isMobileEnv } from 'common/utils/common'
import { isEmptyObject } from 'common/utils/logic/object'
import { getSubVertical, getSubVerticalByPath, SubVertical } from './verticalService'
import { getServiceByPath, ShoppingService } from './shoppingService'
import * as queryString from 'query-string'
import { SpecialEventType } from 'common/constants/specialEvent'

export interface NClickListCard {
  params?: nClickParams
  nClickArea?: NClickArea
  nClickCode?: {
    product?: string
    store?: string
    zzim?: string
    artist?: string
    review?: string
  }
}

export interface NClick<T> {
  nClickArea: NClickArea
  code: T
}

export enum NClickArea {
  HOME = 'HOME',
  STORE = 'STORE',
  STORE_INFO = 'STORE_INFO',
  STORE_NEWS = 'STORE_NEWS',
  STORE_NEWS_DETAIL = 'STORE_NEWS_DETAIL',
  PRODUCT = 'PRODUCT',
  PRODUCT_SIMPLE_REVIEW = 'PRODUCT_SIMPLE_REVIEW',
  PRODUCT_COORDI = 'PRODUCT_COORDI',
  PRODUCT_COORDI_TAB = 'PRODUCT_COORDI_TAB',
  PRODUCT_COORDI_POPUP = 'PRODUCT_COORDI_POPUP',
  PRODUCT_STORE = 'PRODUCT_STORE',
  PRODUCT_COUPON_SECTION = 'PRODUCT_COUPON_SECTION',
  REVIEW_SUMMARY = 'REVIEW_SUMMARY',
  REVIEW_PHOTO_VIDEO_DETAIL = 'REVIEW_PHOTO_VIDEO_DETAIL',
  REVIEW_BEST_PICK_DETAIL = 'REVIEW_BEST_PICK_DETAIL',
  REVIEW_FIRST_WRITTEN_DETAIL = 'REVIEW_FIRST_WRITTEN_DETAIL',
  MY_FIRST_WRITTEN_DETAIL = 'MY_FIRST_WRITTEN_DETAIL',
  REVIEW_DETAIL_LAYER = 'REVIEW_DETAIL_LAYER',
  REVIEW_LIST = 'REVIEW_LIST',
  PRODUCT_QNA = 'PRODUCT_QNA',
  PRODUCT_AITEMS = 'PRODUCT_AITEMS',
  BENEFIT = 'BENEFIT',
  BRAND_STORE_NEWS = 'BRAND_STORE_NEWS',
  BRAND_STORE_PRODUCT = 'BRAND_STORE_PRODUCT',
  BRAND_STORE_EVENT = 'BRAND_STORE_EVENT',
  BRAND_STORE_HEADER = 'BRAND_STORE_HEADER',
  DESIGNER_NEW = 'DESIGNER_NEW',
  DESIGNER_BRAND = 'DESIGNER_BRAND',
  DESIGNER_COLLECTION = 'DESIGNER_COLLECTION',
  DESIGNER_LOOKBOOK = 'DESIGNER_LOOKBOOK',
  DESIGNER_PRODUCT = 'DESIGNER_PRODUCT',
  DESIGNER_DIARY = 'DESIGNER_DIARY',
  DESIGNER_SHOWROOM = 'DESIGNER_SHOWROOM',
  DESIGNER_INTERVIEW = 'DESIGNER_INTERVIEW',
  DESIGNER_SUPPORTERS = 'DESIGNER_SUPPORTERS',
  FOOTER = 'FOOTER',
  REPORT_CENTER = 'REPORT_CENTER',
  BUY = 'BUY',
  WITH = 'WITH',
  SPECIAL_EVENT = 'SPECIAL_EVENT',
  SPECIAL_EVENT_DETAIL = 'SPECIAL_EVENT_DETAIL',
  RANKING_SHOPPING = 'RANKING_SHOPPING',
  RANKING_SHOPPING_DETAIL = 'RANKING_SHOPPING_DETAIL',
  TIP_SHOPPING = 'TIP_SHOPPING',
  TIP_SHOPPING_DETAIL = 'TIP_SHOPPING_DETAIL',
  CATEGORY = 'CATEGORY',
  STYLE_WOMAN = 'STYLE_WOMAN',
  STYLE_MAN = 'STYLE_MAN',
  STYLE_SHOES = 'STYLE_SHOES',
  STYLE_WOMAN_COORDI = 'STYLE_WOMAN_COORDI',
  STYLE_MAN_COORDI = 'STYLE_MAN_COORDI',
  ARTIST = 'ARTIST',
  ARTIST_END = 'ARTIST_END',
  ARTIST_ALL = 'ARTIST_ALL',
  AITEMS = 'AITEMS',
  BRANCH = 'BRANCH',
  BRANCH_DISPLAY = 'BRANCH_DISPLAY',
  BRANCH_NEWS = 'BRANCH_NEWS',
  BRANCH_NEWS_DETAIL = 'BRANCH_NEWS_DETAIL',
  VMD_DETAILS = 'VMD_DETAILS',
  LOCATION = 'LOCATION',
  HOME_MENU = 'HOME_MENU',
  BRAND_TAB = 'BRAND_TAB',
  STYLE_HOME_TAB = 'STYLE_HOME_TAB',
  STORE_DISPLAY = 'STORE_DISPLAY',
  STORE_COORDI = 'STORE_COORDI',
  HAMBURGER_COMMON = 'HAMBURGER_COMMON',
  HAMBURGER_CATEGORY = 'HAMBURGER_CATEGORY',
  HAMBURGER_BRAND = 'HAMBURGER_BRAND',
  HAMBURGER_BRAND_KOR = 'HAMBURGER_BRAND_KOR',
  HAMBURGER_BRAND_ENG = 'HAMBURGER_BRAND_ENG',
  HAMBURGER_BRAND_ETC = 'HAMBURGER_BRAND_ETC',
  HAMBURGER_SERVICE = 'HAMBURGER_SERVICE',
  MY_MENU = 'MY_MENU',
  GNB = 'GNB',
  LNB = 'LNB',
  SEARCH_BAR = 'SEARCH_BAR',
  WRITTEN_REVIEW = 'WRITTEN_REVIEW',
  WRITABLE_REVIEW = 'WRITABLE_REVIEW',
  REVIEW_NORMAL_WRITE = 'REVIEW_NORMAL_WRITE',
  REVIEW_AFTER_USE_WRITE = 'REVIEW_AFTER_USE_WRITE',
  REVIEW_UPDATE = 'REVIEW_UPDATE',
  REVIEW = 'REVIEW',
  MY_SIZE = 'MY_SIZE',
  SNB_WINDOW = 'SNB_WINDOW',
  SNB_SPECIAL_ENDPAGE = 'SNB_SPECIAL_ENDPAGE',
  SNB_DETAIL_ITEM = 'SNB_DETAIL_ITEM',
  GRADE_DETAIL = 'GRADE_DETAIL',
  GRADE_STORE_HOME = 'GRADE_STORE_HOME',
  COUPON = 'COUPON',
  LOCAL_MARKET1 = 'LOCAL_MARKET1',
  LOCAL_MARKET2 = 'LOCAL_MARKET2',
  LOCAL_MARKET_CART = 'LOCAL_MARKET_CART',
  BRAND = 'BRAND',
  KEYWORD = 'KEYWORD',
  TAB = 'TAB',
  TAGPICK_BRIDGE = 'TAGPICK_BRIDGE',
  TAGPICK_MY = 'TAGPICK_MY',
  GRAFOLIO = 'GRAFOLIO',
  PREFERENCE_MALL = 'PREFERENCE_MALL',
  RECOMMEND_REVIEW = 'RECOMMEND_REVIEW',
  HOME_MEAL_NEWS = 'HOME_MEAL_NEWS',
  TRADITIONAL_ALCOHOL_STORES = 'TRADITIONAL_ALCOHOL_STORES',
  GIFT_RECOMMEND = 'GIFT_RECOMMEND',
  GIFT_RECOMMEND_FRM_SEARCH = 'GIFT_RECOMMEND_FRM_SEARCH',
  GIFT_NPAY_CARD = 'GIFT_NPAY_CARD',
  GIFT_NPAY_CARD_FRM_SEARCH = 'GIFT_NPAY_CARD_FRM_SEARCH',
  GIFT_MOBILE_COUPON = 'GIFT_MOBILE_COUPON',
  GIFT_MOBILE_COUPON_FRM_SEARCH = 'GIFT_MOBILE_COUPON_FRM_SEARCH',
  GIFT_DIGITAL_CONTENT = 'GIFT_DIGITAL_CONTENT',
  GIFT_DIGITAL_CONTENT_FRM_SEARCH = 'GIFT_DIGITAL_CONTENT_FRM_SEARCH',
  GIFT_GUIDE_LAYOUT = 'GIFT_GUIDE_LAYOUT',
  GIFT_GUIDE_LAYOUT_FRM_SEARCH = 'GIFT_GUIDE_LAYOUT_FRM_SEARCH',
  GIFT_HOME_SPECIAL = 'GIFT_HOME_SPECIAL',
  GIFT_HOME_DIGITAL_CONTENTS = 'GIFT_HOME_DIGITAL_CONTENTS',
  GIFT_PLAN = 'GIFT_PLAN',
  GIFT_SPECIAL = 'GIFT_SPECIAL',
  GIFT_SPECIAL_FROM_SEARCH = 'GIFT_SPECIAL_FROM_SEARCH',
  GIFT_TAG = 'GIFT_TAG',
  GIFT_GUIDE_TEENAGER = 'GIFT_GUIDE_TEENAGER',
  GIFT_GUIDE_TEENAGER_FROM_SEARCH = 'GIFT_GUIDE_TEENAGER_FROM_SEARCH',
  GIFT_GUIDE_TWENTY = 'GIFT_GUIDE_TWENTY',
  GIFT_GUIDE_TWENTY_FROM_SEARCH = 'GIFT_GUIDE_TWENTY_FROM_SEARCH',
  HALL_OF_FAME = 'HALL_OF_FAME',
  DIRECT_FARM_LOCAL_FOOD_NEWS = 'DIRECT_FARM_LOCAL_FOOD_NEWS',
}

export type NClickAreaType = { [key in NClickArea]: string }

export const NCLICK_PREFIX_MAPPER: NClickAreaType = {
  HOME: 'hom',
  STORE: 'snd',
  STORE_INFO: 'inf',
  STORE_NEWS: 'sli',
  STORE_NEWS_DETAIL: 'ned',
  PRODUCT: 'itm',
  PRODUCT_SIMPLE_REVIEW: 'srv',
  PRODUCT_COORDI: 'cod',
  PRODUCT_COORDI_TAB: 'crd',
  PRODUCT_COORDI_POPUP: 'cop',
  PRODUCT_STORE: 'sst',
  PRODUCT_COUPON_SECTION: 'pcs',
  REVIEW_SUMMARY: 'rev*s',
  REVIEW_PHOTO_VIDEO_DETAIL: 'rev*m',
  REVIEW_BEST_PICK_DETAIL: 'rev*b',
  REVIEW_FIRST_WRITTEN_DETAIL: 'rev*f',
  MY_FIRST_WRITTEN_DETAIL: 'rvf',
  REVIEW_DETAIL_LAYER: 'rev*l',
  REVIEW_LIST: 'rev*p',
  PRODUCT_QNA: 'qna',
  PRODUCT_AITEMS: 'itm',
  BENEFIT: 'bnf',
  BRAND_STORE_NEWS: 'nws',
  DESIGNER_BRAND: 'dbr',
  BRAND_STORE_PRODUCT: 'dpr',
  BRAND_STORE_EVENT: 'hvt',
  BRAND_STORE_HEADER: 'dht',
  DESIGNER_NEW: 'dnw',
  DESIGNER_COLLECTION: 'dco',
  DESIGNER_LOOKBOOK: 'dlb',
  DESIGNER_PRODUCT: 'dpr',
  DESIGNER_DIARY: 'ddi',
  DESIGNER_SHOWROOM: 'dsr',
  DESIGNER_INTERVIEW: 'div',
  DESIGNER_SUPPORTERS: 'dsp',
  FOOTER: 'fot',
  REPORT_CENTER: 'rfd',
  BUY: 'buy',
  WITH: 'with',
  SPECIAL_EVENT: 'eli',
  SPECIAL_EVENT_DETAIL: 'end',
  RANKING_SHOPPING: 'rsp',
  RANKING_SHOPPING_DETAIL: 'rsd',
  TIP_SHOPPING: 'stl',
  TIP_SHOPPING_DETAIL: 'std',
  CATEGORY: 'cat',
  STYLE_WOMAN: 'wom',
  STYLE_MAN: 'man',
  STYLE_SHOES: 'sho',
  STYLE_WOMAN_COORDI: 'wcd',
  STYLE_MAN_COORDI: 'mcd',
  ARTIST: 'artist',
  ARTIST_END: 'artistend',
  ARTIST_ALL: 'artistall',
  AITEMS: 'ait',
  BRANCH: 'bch',
  BRANCH_DISPLAY: 'bdp',
  BRANCH_NEWS: 'bli',
  VMD_DETAILS: 'vmd',
  BRANCH_NEWS_DETAIL: 'nes',
  LOCATION: 'loc',
  HOME_MENU: 'men',
  BRAND_TAB: 'brd',
  STYLE_HOME_TAB: 'tab',
  STORE_DISPLAY: 'sdp',
  STORE_COORDI: 'cod',
  HAMBURGER_COMMON: 'xpa',
  HAMBURGER_CATEGORY: 'xct',
  HAMBURGER_BRAND: 'xbr',
  HAMBURGER_BRAND_KOR: 'xbr*k',
  HAMBURGER_BRAND_ENG: 'xbr*e',
  HAMBURGER_BRAND_ETC: 'xbr*c',
  HAMBURGER_SERVICE: 'xvm',
  MY_MENU: 'men',
  GNB: 'gnb',
  LNB: 'lnb',
  SEARCH_BAR: 'scb',
  WRITTEN_REVIEW: 'mrv',
  WRITABLE_REVIEW: 'prv',
  REVIEW_NORMAL_WRITE: 'wrtrv',
  REVIEW_AFTER_USE_WRITE: 'wrtmnt',
  REVIEW_UPDATE: 'uptrv',
  REVIEW: 'rvw',
  MY_SIZE: 'mysz',
  SNB_WINDOW: 'wsnb',
  SNB_SPECIAL_ENDPAGE: 'end',
  SNB_DETAIL_ITEM: 'itm',
  GRADE_DETAIL: 'grade',
  GRADE_STORE_HOME: 'hgrade',
  COUPON: 'coupon',
  LOCAL_MARKET1: 'grshop1',
  LOCAL_MARKET2: 'grshop2',
  LOCAL_MARKET_CART: 'grcart',
  BRAND: 'bra',
  KEYWORD: 'key',
  TAB: 'tab',
  TAGPICK_BRIDGE: 'stagb',
  TAGPICK_MY: 'stags',
  GRAFOLIO: 'gro',
  PREFERENCE_MALL: 'pfm',
  RECOMMEND_REVIEW: 'pre',
  HOME_MEAL_NEWS: 'tip',
  TRADITIONAL_ALCOHOL_STORES: 'stl',
  GIFT_RECOMMEND: 'rcd',
  GIFT_RECOMMEND_FRM_SEARCH: 'rcl',
  GIFT_NPAY_CARD: 'ncd',
  GIFT_NPAY_CARD_FRM_SEARCH: 'ncl',
  GIFT_MOBILE_COUPON: 'mcd',
  GIFT_MOBILE_COUPON_FRM_SEARCH: 'mcl',
  GIFT_DIGITAL_CONTENT: 'dcd',
  GIFT_DIGITAL_CONTENT_FRM_SEARCH: 'dcl',
  GIFT_GUIDE_LAYOUT: 'tgd',
  GIFT_GUIDE_LAYOUT_FRM_SEARCH: 'tgl',
  GIFT_HOME_SPECIAL: 'hom*s',
  GIFT_HOME_DIGITAL_CONTENTS: 'hom*d',
  GIFT_PLAN: 'hbp',
  GIFT_SPECIAL: 'sdd',
  GIFT_SPECIAL_FROM_SEARCH: 'sdl',
  GIFT_TAG: 'hkp',
  GIFT_GUIDE_TEENAGER: '10d',
  GIFT_GUIDE_TEENAGER_FROM_SEARCH: '10l',
  GIFT_GUIDE_TWENTY: '20d',
  GIFT_GUIDE_TWENTY_FROM_SEARCH: '20l',
  HALL_OF_FAME: 'fame',
  DIRECT_FARM_LOCAL_FOOD_NEWS: 'new',
}

type SubVerticalNsCode = { [key in SubVertical]?: string }

const subVerticalNsCode: SubVerticalNsCode = {
  DEPARTMENT: 'dep3',
  OUTLET: 'olt3',
  STYLE: 'stl3',
  FASHION_BRAND: 'brand',
  DESIGNER: 'designer',
  BEAUTY: 'beauty',
  HOME_LIVING: 'homedeco',
  HANDMADE: 'handmade',
  STATIONERY: 'stationery',
  DIRECT_FARM: 'sanji2',
  LOCAL_FOOD: 'local2',
  TRADITIONAL_ALCOHOL: 'alcohol',
  HOME_MEAL: 'homemeal',
  KIDS: 'kids',
  PET: 'pet',
  PLAY: 'play',
  ART: 'art',
  FOREIGN: 'global',
}

type ShoppingServiceNsCode = { [key in ShoppingService]?: string }

const shoppingServiceNsCode: ShoppingServiceNsCode = {
  MY: 'my',
  REVIEW: 'review',
  TAGPICK_BRIDGE: 'tagpickbridge',
  TAGPICK_MY: 'tagpickconfig​',
  GIFT: 'gift',
}

export const getNsCodeBySubVertical = (subVertical: SubVertical): string => {
  if (!subVerticalNsCode[subVertical]) return null
  return `${isMobileEnv ? 'Mshoppingw' : 'shoppingw'}.${subVerticalNsCode[subVertical]}`
}

export const getNsCodeByService = (service: ShoppingService): string => {
  if (!service) return null
  return `${isMobileEnv ? 'Mshopping' : 'shopping'}.${shoppingServiceNsCode[service]}`
}

export const getNsCodeByHome = (): string => {
  return `${isMobileEnv ? 'Mshopping2' : 'shopping2'}.home`
}

export const getNsCodeByPath = (): string => {
  if (!isBrowser) return
  const service = getServiceByPath(window.location.pathname)
  if (service) return getNsCodeByService(service)
  const subVertical = getSubVerticalByPath(window.location.pathname)
  if (subVertical) return getNsCodeBySubVertical(subVertical)

  const menu = getNsCodeByMenu(window.location.pathname, window.location.search)
  if (menu) return menu

  return null
}

export const getNsCodeByMenu = (pathname: string, params?: string) => {
  const isMenu = /menu/.test(pathname)
  if (!isMenu) return null

  const queryParams = queryString.parse(params)
  const subVerticalText = queryParams && queryParams.type

  if (subVerticalText) {
    const subVertical = getSubVertical(`${subVerticalText}`)
    return getNsCodeBySubVertical(subVertical)
  }

  return getNsCodeByHome()
}

export const getNClickPrefix = (area: NClickArea): string => NCLICK_PREFIX_MAPPER[area]

export interface nClickParams {
  i?: string
  r?: number
  g?: string
}

export const getNClickClassName = (
  area: NClickArea,
  code: string,
  params?: nClickParams,
  removeAt?: boolean,
): string => {
  const baseCode = `${removeAt ? '' : '@'}N=a:${getNClickPrefix(area)}.${code}`
  if (!params || isEmptyObject(params)) return baseCode
  return [
    baseCode,
    ...Object.keys(params)
      .filter(key => params[key])
      .map(key => `${key}:${params[key]}`),
  ].join(',')
}

export const getNClickOfProductList = (nClickListCard: NClickListCard, productId: string) => {
  if (!nClickListCard) return ''

  const { nClickArea, nClickCode, params } = nClickListCard
  return getNClickClassName(nClickArea, (nClickCode && nClickCode.product) || 'item', params || { i: productId })
}

export const getNClickOfZzimInList = (nClickListCard: NClickListCard, productId: string) => {
  if (!nClickListCard) return ''

  const { nClickArea, nClickCode, params } = nClickListCard
  return getNClickClassName(nClickArea, (nClickCode && nClickCode.zzim) || 'ifav', params || { i: productId })
}

export const getNClickOfStoreInList = (nClickListCard: NClickListCard, channelId: string) => {
  if (!nClickListCard) return ''

  const { nClickArea, nClickCode, params } = nClickListCard
  return getNClickClassName(nClickArea, (nClickCode && nClickCode.store) || 'istore', { ...params, i: channelId })
}

export const getNClickOfArtistInList = (nClickListCard: NClickListCard, brandId: string) => {
  if (!nClickListCard) return ''

  const { nClickArea, nClickCode, params } = nClickListCard
  return getNClickClassName(nClickArea, (nClickCode && nClickCode.artist) || 'iartist', { ...params, i: brandId })
}

export const getNClickOfReviewInList = (nClickListCard: NClickListCard, productId: string) => {
  if (!nClickListCard) return ''

  const { nClickArea, nClickCode, params } = nClickListCard
  return getNClickClassName(nClickArea, (nClickCode && nClickCode.review) || 'irev', { ...params, i: productId })
}

export const getEventNClickArea = (specialEventType: SpecialEventType, subVertical: SubVertical) => {
  if (subVertical === SubVertical.FOREIGN) {
    if (specialEventType === SpecialEventType.RANKING_SHOPPING) return NClickArea[NClickArea.RANKING_SHOPPING]
    if (specialEventType === SpecialEventType.TIP_SHOPPING) return NClickArea[NClickArea.TIP_SHOPPING]
  }

  return NClickArea[NClickArea.SPECIAL_EVENT]
}

export const getEventDetailNClickArea = (specialEventType: SpecialEventType, subVertical: SubVertical) => {
  if (subVertical === SubVertical.FOREIGN) {
    if (specialEventType === SpecialEventType.RANKING_SHOPPING) return NClickArea[NClickArea.RANKING_SHOPPING_DETAIL]
    if (specialEventType === SpecialEventType.TIP_SHOPPING) return NClickArea[NClickArea.TIP_SHOPPING_DETAIL]
  }

  return NClickArea[NClickArea.SPECIAL_EVENT_DETAIL]
}
